export default __webpack_public_path__ + "fonts/iconfont.8146c8e9930b82d29ac4a90e4bd6a529.ttf";